import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { LogOut, ClipboardList, Users } from 'lucide-react';
import './LayoutGarcom.css';

const LayoutGarcom = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
    window.location.href = '/garcom/login';
  };

  return (
    <div className="layout-garcom">
      <header className="header-garcom">
        <div className="header-left">
          <ClipboardList size={24} />
          <h1>Garçom - Sistema de Comandas</h1>
        </div>
        <div className="header-right">
          <div className="user-info">
            <span>Garçom: {user?.nome || 'Usuário'}</span>
          </div>
          <button onClick={handleLogout} className="btn-logout-garcom">
            <LogOut size={18} />
            Sair
          </button>
        </div>
      </header>

      <nav className="nav-garcom">
        <button 
          onClick={() => navigate('/garcom')}
          className={`nav-item-garcom ${location.pathname === '/garcom' ? 'active' : ''}`}
        >
          <ClipboardList size={20} />
          Comandas
        </button>
        <button 
          onClick={() => navigate('/garcom/mesas')}
          className={`nav-item-garcom ${location.pathname.startsWith('/garcom/mesas') ? 'active' : ''}`}
        >
          <Users size={20} />
          Mesas
        </button>
      </nav>

      <main className="main-garcom">
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutGarcom;

